export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const addNotification = notif => ({
  type: ADD_NOTIFICATION,
  payload: notif,
});
